import script from "./BaseVuexFormItem.vue?vue&type=script&lang=js"
export * from "./BaseVuexFormItem.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__